export default __webpack_public_path__ + "static/login-16d8a72d4e73e47a4adbe355e09b5d43.jpg";